export function checkIsMissingHeaders(csvHeaders: Array<string>) {
    // Array of required header in CSV File
    const requiredHeaders = ["PARENT_FIRST_NAME", "PARENT_LAST_NAME", "PARENT_EMAIL", "PARENT_PHONE_NUMBER", "CHILD_FIRST_NAME", "ADDRESS_LINE_1", "ADDRESS_LINE_2", "CITY", "STATE_CODE", "ZIP_CODE"];
    const headers = csvHeaders;
    const missingHeaders = [];

    for (const requiredHeader of requiredHeaders) {
        if (!headers.includes(requiredHeader)) {
            missingHeaders.push(requiredHeader);
        }
    }

    if (missingHeaders.length === 0) {
        return { isMissingHeaders: false, missingHeaders }; // All required headers exist
    } else {
        return { isMissingHeaders: true, missingHeaders }; // Some required headers are missing
    }
}